/**
 * @deprecated
 */
export var MULTIPLAYER_TRACE_DOC_PREFIX = 'd0cd0c';
export var MULTIPLAYER_TRACE_DEBUG_PREFIX = 'debdeb';
export var MULTIPLAYER_TRACE_CONTINUOUS_DEBUG_PREFIX = 'cdbcdb';
export var MULTIPLAYER_TRACE_DEBUG_SESSION_SHORT_ID_LENGTH = 16;
/**
 * @deprecated Use MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_HTTP_URL instead
 */
export var MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_URL = 'https://api.multiplayer.app/v1/traces';
/**
 * @deprecated Use MULTIPLAYER_OTEL_DEFAULT_LOGS_EXPORTER_HTTP_URL instead
 */
export var MULTIPLAYER_OTEL_DEFAULT_LOGS_EXPORTER_URL = 'https://api.multiplayer.app/v1/logs';
export var MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_HTTP_URL = 'https://otlp.multiplayer.app/v1/traces';
export var MULTIPLAYER_OTEL_DEFAULT_LOGS_EXPORTER_HTTP_URL = 'https://otlp.multiplayer.app/v1/logs';
export var MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_GRPC_URL = 'https://otlp.multiplayer.app:4317/v1/traces';
export var MULTIPLAYER_OTEL_DEFAULT_LOGS_EXPORTER_GRPC_URL = 'https://otlp.multiplayer.app:4317/v1/logs';
export var MULTIPLAYER_BASE_API_URL = 'https://api.multiplayer.app';
export var MULTIPLAYER_ATTRIBUTE_PREFIX = 'multiplayer.';
export var ATTR_MULTIPLAYER_WORKSPACE_ID = 'multiplayer.workspace.id';
export var ATTR_MULTIPLAYER_PROJECT_ID = 'multiplayer.project.id';
export var ATTR_MULTIPLAYER_PLATFORM_ID = 'multiplayer.platform.id';
export var ATTR_MULTIPLAYER_CONTINUOUS_SESSION_AUTO_SAVE = 'multiplayer.session.auto-save';
export var ATTR_MULTIPLAYER_CONTINUOUS_SESSION_AUTO_SAVE_REASON = 'multiplayer.session.auto-save.reason';
export var ATTR_MULTIPLAYER_PLATFORM_NAME = 'multiplayer.platform.name';
export var ATTR_MULTIPLAYER_CLIENT_ID = 'multiplayer.client.id';
export var ATTR_MULTIPLAYER_INTEGRATION_ID = 'multiplayer.integration.id';
export var ATTR_MULTIPLAYER_SESSION_ID = 'multiplayer.session.id';
export var ATTR_MULTIPLAYER_HTTP_PROXY = 'multiplayer.http.proxy';
export var ATTR_MULTIPLAYER_HTTP_PROXY_TYPE = 'multiplayer.http.proxy.type';
export var ATTR_MULTIPLAYER_HTTP_REQUEST_BODY = 'multiplayer.http.request.body';
export var ATTR_MULTIPLAYER_HTTP_RESPONSE_BODY = 'multiplayer.http.response.body';
export var ATTR_MULTIPLAYER_HTTP_REQUEST_HEADERS = 'multiplayer.http.request.headers';
export var ATTR_MULTIPLAYER_HTTP_RESPONSE_HEADERS = 'multiplayer.http.response.headers';
export var ATTR_MULTIPLAYER_HTTP_RESPONSE_BODY_ENCODING = 'multiplayer.http.response.body.encoding';
export var ATTR_MULTIPLAYER_RPC_REQUEST_MESSAGE = 'multiplayer.rpc.request.message';
export var ATTR_MULTIPLAYER_RPC_REQUEST_MESSAGE_ENCODING = 'multiplayer.rpc.request.message.encoding';
export var ATTR_MULTIPLAYER_RPC_RESPONSE_MESSAGE = 'multiplayer.rpc.response.message';
export var ATTR_MULTIPLAYER_GRPC_REQUEST_MESSAGE = 'multiplayer.rpc.grpc.request.message';
export var ATTR_MULTIPLAYER_GRPC_REQUEST_MESSAGE_ENCODING = 'multiplayer.rpc.request.message.encoding';
export var ATTR_MULTIPLAYER_GRPC_RESPONSE_MESSAGE = 'multiplayer.rpc.grpc.response.message';
export var ATTR_MULTIPLAYER_MESSAGING_MESSAGE_BODY = 'multiplayer.messaging.message.body';
export var ATTR_MULTIPLAYER_MESSAGING_MESSAGE_BODY_ENCODING = 'multiplayer.messaging.message.body.encoding';
export var ATTR_MULTIPLAYER_SESSION_RECORDER_VERSION = 'multiplayer.session-recorder.version';
export var ATTR_MULTIPLAYER_ISSUE_CUSTOM_HASH = 'multiplayer.issue.custom-hash';
export var ATTR_MULTIPLAYER_ISSUE_HASH = 'multiplayer.issue.hash';
export var ATTR_MULTIPLAYER_ISSUE_COMPONENT_HASH = 'multiplayer.issue.component-hash';
export var ATTR_MULTIPLAYER_USER_HASH = 'multiplayer.user.hash';
export var MASK_PLACEHOLDER = '***MASKED***';
//# sourceMappingURL=constants.base.js.map